/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureCspPartner extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureCspPartner");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureCspPartner.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureCspPartner>): ServiceAccountNativeDetailsForAzureCspPartner {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureCspPartner(), model);
        ServiceAccountNativeDetailsForAzureCspPartner.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureCspPartner>): ServiceAccountNativeDetailsForAzureCspPartner {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureCspPartner.newInstance(<ServiceAccountNativeDetailsForAzureCspPartner> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureCspPartner) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureCspPartner.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureCspPartner): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureCspPartner.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * MPN ID of the Indirect Partner (Tier2MpnId)
     */
    partner_mpn_id: string;

    /**
     * Partner Name
     */
    partner_name: string;

}
